import { Skeleton } from '@/components/ui/skeleton'
import React from 'react'

const MemberItemLoader = () => (
    <div className='flex items-center justify-between w-full'>
      <div className='flex items-center gap-1'>
        <Skeleton className="w-11 h-11 rounded-full bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
        <div className='flex flex-col gap-1'>
          <Skeleton className="w-16 h-5 rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
          <Skeleton className="w-11 h-5 rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
        </div>
      </div>
      <div className='flex flex-col gap-1'>
        <Skeleton className="w-10 h-10 rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
        <Skeleton className="w-7 h-5 rounded bg-gradient-to-r from-[#EDEDED] to-[#D7D7D7]" />
      </div>
    </div>
  )

export default MemberItemLoader